import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AbpModule } from 'abp-ng2-module';
import { UtilsModule } from '@shared/utils/utils.module';
import { CommonLookupServiceProxy } from '@shared/service-proxies/service-proxies';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-report-shareable-link',
  templateUrl: './report-shareable-link.component.html',
  styleUrls: ['./report-shareable-link.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule,
    UtilsModule,
    AbpModule
  ]
})
export class ReportShareableLinkComponent implements OnInit {

  shareKey: string = '';
  isLoading = true;
  isInvalid = false;
  reportUrl: any;

  constructor(
    private route: ActivatedRoute,
    private _commonLookupServiceProxy: CommonLookupServiceProxy,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.shareKey = this.route.snapshot.paramMap.get('key') ?? '';

    if (this.shareKey) {
      this.loadSharedReport();
    } else {
      this.isLoading = false;
      this.isInvalid = true;
    }
  }

  loadSharedReport() {
    this._commonLookupServiceProxy.GetSharedReport(this.shareKey).subscribe({
      next: (response) => {

        this.isLoading = false;

        if (response?.isSuccess && response?.data) {
          this.reportUrl = this.transform(response.data);   // Already a direct S3 URL

          if (!this.reportUrl) {
            this.isInvalid = true;
          }
        } else {
          this.isInvalid = true;
        }
      },
      error: () => {
        this.isLoading = false;
        this.isInvalid = true;
      }
    });
  }

  transform(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
